// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__26poS","topBottomGutter":"Layout_topBottomGutter__27Ay2"};